(() => {
  const videos = [...document.querySelectorAll('video[data-aziv-managed-video]')];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection?.saveData;
  function attach(video) {
    if (video.dataset.azivAttached) return;
    video.dataset.azivAttached = 'true';
    [video, ...video.querySelectorAll('source')].forEach(node => {
      if (node.dataset.azivSrc) node.src = node.dataset.azivSrc;
    });
    video.load();
  }
  function enter(video) {
    if (reduced || saveData || document.hidden) return;
    attach(video);
    if (video.hasAttribute('data-aziv-autoplay')) video.play().catch(() => {});
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => {
      target.dataset.azivVisible = String(isIntersecting);
      if (isIntersecting) enter(target);
      else target.pause();
    });
  }, {rootMargin: '0px', threshold: 0.01}) : null;
  videos.forEach(video => {
    if (observer) observer.observe(video);
    else attach(video);
    video.addEventListener('pointerdown', () => attach(video), {passive:true});
    video.addEventListener('focus', () => attach(video));
  });
  // Existing audio pills keep their handlers; sources must exist before those handlers play.
  document.addEventListener('click', event => {
    const button = event.target.closest('button, label, input[type="checkbox"], [role="switch"]');
    if (!button || !/audio|sound|mute/i.test(button.textContent + ' ' + button.getAttribute('aria-label'))) return;
    let container = button.parentElement;
    for (let depth=0; container && depth<3; depth++, container=container.parentElement) {
      const video = container.querySelector('video[data-aziv-managed-video]');
      if (video) { attach(video); break; }
    }
  }, true);
  document.addEventListener('visibilitychange', () => {
    videos.forEach(video => {
      if (document.hidden) video.pause();
      else if (video.dataset.azivVisible === 'true') enter(video);
    });
  });
})();
